 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		55: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		55: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"22":"affiliate-page","23":"algolia-search","24":"algolia-search-local","25":"card-error","26":"cart-drawer","27":"christmas-holiday-gift-cards-page","28":"consumer-checkout-page","29":"consumer-checkout-page-footer-content","30":"create-a-card-carrier","31":"create-a-card-landing","32":"create-a-card-review","33":"designer-gift-cards","34":"diwali-holiday-gift-cards-page","35":"gift-card-app-page","36":"gift-card-balance-check-page","37":"gift-card-occasions","38":"greeting-card-landing-page","39":"handwritten-page","40":"hanukkah-holiday-gift-cards-page","41":"home-page","42":"kwanzaa-holiday-gift-cards-page","43":"legit-page","45":"mastercard-pla-landing-page","46":"newsletter-signup-page","47":"open-loop-activate-check-balance","48":"open-loop-virtual-exchange","49":"order-details","50":"order-status","51":"pla-landing-page-container","52":"redeem-gift","53":"redeem-gyp-gift","54":"reviews-page","56":"smb-apply","57":"smb-cobrand-cards","58":"smb-order-details","59":"smb-order-details-pdf-invoice","60":"smb-order-flow","61":"smb-order-flow-cancelled","62":"smb-order-flow-confirmation","63":"smb-order-flow-customize-product","64":"smb-order-flow-footer-content","65":"smb-order-flow-landing","66":"smb-order-flow-login","67":"smb-order-flow-merchant","68":"smb-order-flow-merchant-directory","69":"smb-order-flow-place-order","70":"smb-order-flow-product-details","71":"smb-order-flow-registration","72":"smb-resubmission-portal","73":"store-review-list-portal","74":"update-failed-email-recipient","75":"update-payment-method","76":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"86e8e05f","1":"91dc8e2b","2":"205c50a5","3":"753401e8","4":"0637017f","5":"8b8f8a37","6":"35254590","7":"163c6b3d","8":"90829851","9":"19c973c3","10":"71c17e9a","11":"d9d90295","12":"9e1bf9c6","13":"5a820965","14":"9833c5c6","15":"2ee52ac1","16":"ac76bdad","17":"febee5b6","18":"890f44d0","19":"bd97000d","20":"13f04582","21":"c4aa4c98","22":"70b98883","23":"56c25840","24":"7921f089","25":"c9e5329d","26":"ff285b55","27":"63a1f1e1","28":"7a13552c","29":"01ae61d7","30":"c5e05148","31":"bbfe1225","32":"1f9a3fdc","33":"1e054bd0","34":"c34c0001","35":"e5bda84a","36":"36d46f88","37":"f6ef35b9","38":"99bba251","39":"4ea8ca37","40":"6f5e59ff","41":"d373f718","42":"1b07a38f","43":"813f7512","45":"8ea8c70e","46":"0606eed9","47":"9bc50b88","48":"07fd00c1","49":"cd01043e","50":"3396dda5","51":"4576cd01","52":"e8020eaf","53":"c3380dfd","54":"2b4a5aad","56":"cd23cd4b","57":"c70ca4cb","58":"a9f153d8","59":"af15ae24","60":"40dddb63","61":"9de19bdf","62":"c4b791c3","63":"bb8d9e22","64":"7dc76305","65":"7e504e67","66":"fcc04a77","67":"fc8e4674","68":"c9635953","69":"06a973f9","70":"55778c52","71":"518bdd36","72":"cda205ba","73":"b719cf3c","74":"dfd25553","75":"5bd2ba76","76":"48e8030c","78":"6e0f097a","79":"0c29cd93","80":"7ce5d5eb","81":"60172a48","82":"429c840c","83":"f570b196","84":"0061dc29","85":"85cc5ace","86":"6e1c014f","87":"7be05c95","88":"68f1a418","89":"1a7d159b","90":"41f6ab8f"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"31":1,"50":1,"63":1,"82":1,"85":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"22":"affiliate-page","23":"algolia-search","24":"algolia-search-local","25":"card-error","26":"cart-drawer","27":"christmas-holiday-gift-cards-page","28":"consumer-checkout-page","29":"consumer-checkout-page-footer-content","30":"create-a-card-carrier","31":"create-a-card-landing","32":"create-a-card-review","33":"designer-gift-cards","34":"diwali-holiday-gift-cards-page","35":"gift-card-app-page","36":"gift-card-balance-check-page","37":"gift-card-occasions","38":"greeting-card-landing-page","39":"handwritten-page","40":"hanukkah-holiday-gift-cards-page","41":"home-page","42":"kwanzaa-holiday-gift-cards-page","43":"legit-page","45":"mastercard-pla-landing-page","46":"newsletter-signup-page","47":"open-loop-activate-check-balance","48":"open-loop-virtual-exchange","49":"order-details","50":"order-status","51":"pla-landing-page-container","52":"redeem-gift","53":"redeem-gyp-gift","54":"reviews-page","56":"smb-apply","57":"smb-cobrand-cards","58":"smb-order-details","59":"smb-order-details-pdf-invoice","60":"smb-order-flow","61":"smb-order-flow-cancelled","62":"smb-order-flow-confirmation","63":"smb-order-flow-customize-product","64":"smb-order-flow-footer-content","65":"smb-order-flow-landing","66":"smb-order-flow-login","67":"smb-order-flow-merchant","68":"smb-order-flow-merchant-directory","69":"smb-order-flow-place-order","70":"smb-order-flow-product-details","71":"smb-order-flow-registration","72":"smb-resubmission-portal","73":"store-review-list-portal","74":"update-failed-email-recipient","75":"update-payment-method","76":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"7176885d","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"21f59128","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"c8c378cd","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"31d6cfe0","75":"31d6cfe0","76":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"ab2267f6","83":"31d6cfe0","84":"31d6cfe0","85":"c8c378cd","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://sitecdn.giftcardgranny.com/19885/react/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpgift-card-granny-react"] = this["webpackJsonpgift-card-granny-react"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
